"use client";
import React, {useState} from "react";
import {IconWrapper, InputWrap, StyledInput, StyledTexfield} from "./Texfield.styles";

const TextField = ({
    hasicon,
    placeholder,
    type,
    onChange,
    value,
    label,
    field_Name,
    height,
    variant = "input",
    noMargin,
    parentClass,
    ...props
}) => {
    const [isClicked, setIsClicked] = useState(false);

    const handleField = () => {
        setIsClicked(!isClicked);
    };

    return (
        <InputWrap>
            {label && <label htmlFor={field_Name}>{label}</label>}
            <StyledTexfield
                onClick={handleField}
                $hasicon={hasicon}
                $variant={variant}
                $noMargin={noMargin}
                className={parentClass}
                style={{
                    outline: `1px solid #ddd`,
                }}>
                <IconWrapper>{hasicon}</IconWrapper>
                {variant == "input" && (
                    <StyledInput
                        {...props}
                        type={type}
                        placeholder={placeholder}
                        onChange={onChange}
                        value={value}
                        autoComplete="off"
                        id={field_Name}
                    />
                )}

                {variant == "textarea" && (
                    <textarea
                        {...props}
                        type={type}
                        placeholder={placeholder}
                        onChange={onChange}
                        value={value}
                        autoComplete="off"
                        id={field_Name}></textarea>
                )}
            </StyledTexfield>
        </InputWrap>
    );
};

export default TextField;
